import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment as env } from '../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class AppService {
	http = inject(HttpClient);

	private apiUrl: string = `${env.ssl ? 'https' : 'http'}://${env.restServer}:${env.restServerPort}`;
	private _version = signal<string>('v1.0.0');
	version = this._version.asReadonly();

	initialize() {
		this.http.get<{ version: string }>(`${this.apiUrl}/api/version`).subscribe({
			next: response => {
				this._version.set(response.version);
			},
			error: err => {
				console.error('Error fetching version:', err);
			},
		});
	}
}
